import { render, staticRenderFns } from "./Contacts.vue?vue&type=template&id=0ecd1c4d&scoped=true"
import script from "./Contacts.vue?vue&type=script&lang=js"
export * from "./Contacts.vue?vue&type=script&lang=js"
import style0 from "./index.scss?vue&type=style&index=0&id=0ecd1c4d&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecd1c4d",
  null
  
)

export default component.exports